import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createBlock as _createBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  class: "fundingP sec-main pt-0",
  id: "main"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<section class=\"fundingP-hero\"><div class=\"container-fluid\"><div class=\"row text-center\"><div class=\"col-12 g-0\"><picture><source srcset=\"resources/images/aiot/2026_web.png\" alt=\"第二屆青創點睛竹夢成金\" media=\"(min-width: 768px)\"><img srcset=\"resources/images/aiot/2026_mobile.png\" alt=\"第二屆青創點睛竹夢成金\" class=\"d-block img-fluid mx-auto\" width=\"1440\"></picture></div></div></div></section>", 1)
const _hoisted_3 = { class: "fundingP-main" }
const _hoisted_4 = { class: "container-lg" }
const _hoisted_5 = { class: "col-sm-10 mx-auto" }
const _hoisted_6 = {
  style: {"--bs-breadcrumb-divider":"'>'"},
  "aria-label": "breadcrumb"
}
const _hoisted_7 = { class: "breadcrumb" }
const _hoisted_8 = { class: "breadcrumb-item" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("li", {
  class: "breadcrumb-item active",
  "aria-current": "page"
}, "資源搜尋 - AIoT 加速器", -1)
const _hoisted_10 = { class: "col-12 mx-auto fundingP-board px-3 py-md-5 px-md-0 bg-gray" }
const _hoisted_11 = { class: "filter-tabs" }
const _hoisted_12 = {
  class: "nav justify-content-center",
  id: "funding-tab",
  role: "tablist"
}
const _hoisted_13 = {
  class: "nav-item",
  role: "presentation"
}
const _hoisted_14 = {
  class: "nav-item",
  role: "presentation"
}
const _hoisted_15 = {
  class: "nav-item",
  role: "presentation"
}
const _hoisted_16 = {
  class: "nav-item",
  role: "presentation"
}
const _hoisted_17 = {
  class: "nav-item",
  role: "presentation"
}
const _hoisted_18 = {
  class: "tab-content",
  id: "funding-tabContent"
}
const _hoisted_19 = /*#__PURE__*/_createElementVNode("h1", { class: "visually-hidden" }, "AIoT 加速器", -1)
const _hoisted_20 = /*#__PURE__*/_createStaticVNode("<div class=\"row\"><div class=\"col-md-10 mx-auto\"><div class=\"mb-5\"><h2 class=\"h2 mb-md-3 mb-2\">新竹 AIoT 加速器</h2><p class=\"h4\"> 新竹AIoT加速器是StarFab與新竹縣政府攜手合作的【115年青年創新創業培育計畫】，從2022年起共同為大新竹地區量身打造的AIoT為主題之定向育成加速器，鏈結大新竹地區的企業，包含安格科技、晶瑞光電、誠屏科技、睿騰能源、精誠資訊、緯謙科技、邁特電子，7家企業擔任企業導師，邀請全台具備創新技術的青年創業家進行提案，運用「以大（企業）帶小（青創）」的機制從中媒合具備潛力之青創與企業合作。在企業導師與創業輔導師的雙軌協助下，串連各方資源扶植青創快速掌握市場端的需求，並透過技術支援、場域驗證、行銷通路等多面向合作，深度結合雙方優勢、搶攻科技新商機。 </p></div><div class=\"mb-5\"><h2 class=\"h2 mb-md-3 mb-2\">計畫資源</h2><p class=\"h4\"> ・企業資源<br>七大企業提供合作場域、市場通路、國際鏈結、技術支援等合作資源，並進行為期4個月共創輔導期，由專屬企業導師手把手傳承實戰營運經驗，加持新創加速成長。<br> ・募資協助<br>邀請專業投資機構（如創投、企業投資部門等）進行專業諮詢輔導與募資課程，協助新創掌握募資的技巧。<br> ・國際市場拓展<br>透過國際合作夥伴資源，協助新創對接馬來西亞市場，促進技術交流與市場價值探索，為新創開創國際合作機會。<br> ・場域驗證補助<br>透過場域驗證評選會篩選5組潛力團隊，發放場域驗證補助金，促成新創與企業達成實質合作。<br> ・亮點行銷<br>透過網路、新聞、產業媒體各式曝光，提升新創知名度，並於年末舉辦成果博覽會(Demo Day)，邀請新創團隊與企業導師共同參與，透過攤位展示和簡報發表吸引媒體報導及產業關注！ </p></div><div class=\"mb-5\"><h2 class=\"h2 mb-md-3 mb-2\">報名連結</h2><p class=\"h4\"><a href=\"https://pse.is/2026HsinchuAIoT\" title=\"另開新視窗\" target=\"_blank\">https://pse.is/2026HsinchuAIoT</a></p></div><div class=\"mb-5\"><h2 class=\"h2 mb-md-3 mb-2\">相關時程</h2><p class=\"h4\"> ・徵案期間：4月10日（五）~ 5月22日（五）<br> ・書審階段：5月25日（一）~ 6月17日（三）<br> ・公告新創入選名單：6月18日（五）<br> ・新創徵選與媒合會：6月30日（二）<br> ・東南亞市場拓商 第一階段評選：7月7日（二）<br> 主辦/執行單位保有最終修改、變更本活動之權利 </p></div><div class=\"mb-5\"><h2 class=\"h2 mb-md-3 mb-2\">申請資格</h2><p class=\"h4\"> ・致力於智慧物聯網(AIoT)、人工智慧(Artificial Intelligence)、生成式AI、雲端運算等相關創新技術，並運用於智慧製造、智慧醫療、永續經營、無人載具、生成式AI等相關領域之中小企業或新創公司。<br> ・尚未成立公司，已投入智慧物聯網(AIoT)、人工智慧(Artificial Intelligence)、生成式AI、雲端運算等相關技術開發之團隊。<br> ・參加作品所包含的各項組成技術，其來源不可違反任何法律規定或具法律效力之合約規範。<br> ・參加作品已可實際展示功能，並可提出具體商業服務模式規劃的團隊。<br> ・參與：建議核心團隊至少一位參與企業媒合流程。<br> ＊中小企業認定標準: 實收資本額在新台幣一億元以下者，或經常僱用員工數未滿二百人者。 </p></div><div class=\"mb-5\"><h2 class=\"h2 mb-md-3 mb-2\">新竹 AIoT 加速器</h2><p class=\"h4\"> 聯絡人：Anna Fang<br> 聯絡電話：+886 2 27038738 #15<br> E-mail：anna.fang@starfabx.com </p></div></div></div>", 1)
const _hoisted_21 = [
  _hoisted_20
]
const _hoisted_22 = {
  key: 0,
  class: "funding-year"
}
const _hoisted_23 = { class: "row align-items-center select-filter bg-transparent" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("label", {
  for: "staticEmail",
  class: "h3 p-0 col-md-auto col-12 col-form-label"
}, "年份", -1)
const _hoisted_25 = { class: "col-md col-12 p-0" }
const _hoisted_26 = ["value"]
const _hoisted_27 = {
  key: 1,
  class: "d-grid gap-70"
}
const _hoisted_28 = { class: "row" }
const _hoisted_29 = { class: "col-md-10 mx-auto" }
const _hoisted_30 = { class: "tutor-list" }
const _hoisted_31 = { class: "d-grid" }
const _hoisted_32 = { class: "tutor-item-logo flex-shrink-0" }
const _hoisted_33 = ["src", "alt"]
const _hoisted_34 = { class: "tutor-item-info flex-grow-1" }
const _hoisted_35 = { class: "mb-2" }
const _hoisted_36 = { class: "tutor-name-row frcb g-3" }
const _hoisted_37 = { class: "h6 text-primary" }
const _hoisted_38 = ["data-bs-target"]
const _hoisted_39 = /*#__PURE__*/_createElementVNode("div", { class: "h3 mb-2" }, "出題簡介", -1)
const _hoisted_40 = { class: "h4" }
const _hoisted_41 = { class: "btn-group frcc justify-content-md-end flex-wrap" }
const _hoisted_42 = ["href"]
const _hoisted_43 = ["href"]
const _hoisted_44 = ["href"]
const _hoisted_45 = { class: "row" }
const _hoisted_46 = { class: "col-md-10 mx-auto mb-5" }
const _hoisted_47 = /*#__PURE__*/_createElementVNode("h2", { class: "h2 head-row mb-md-4" }, "輔導團隊", -1)
const _hoisted_48 = { class: "row row-cols-1 row-cols-sm-2 row-cols-md-3 cols-list team-list" }
const _hoisted_49 = { class: "team-item border bg-white h-100 p-0" }
const _hoisted_50 = ["href"]
const _hoisted_51 = { class: "team-card-logo" }
const _hoisted_52 = ["src", "alt"]
const _hoisted_53 = { class: "team-card-info px-3 py-1 border-top text-center" }
const _hoisted_54 = { class: "h6 team-card-name text-primary mb-3" }
const _hoisted_55 = /*#__PURE__*/_createElementVNode("p", { class: "h5 text-decoration-underline text-link-gray" }, "完整介紹", -1)
const _hoisted_56 = {
  key: 0,
  class: "funding-year"
}
const _hoisted_57 = { class: "row align-items-center select-filter bg-transparent" }
const _hoisted_58 = /*#__PURE__*/_createElementVNode("label", {
  for: "staticEmail",
  class: "h3 p-0 col-md-auto col-12 col-form-label"
}, "年份", -1)
const _hoisted_59 = { class: "col-md col-12 p-0" }
const _hoisted_60 = ["value"]
const _hoisted_61 = { class: "row" }
const _hoisted_62 = {
  key: 0,
  class: "col-md-10 mx-auto"
}
const _hoisted_63 = /*#__PURE__*/_createElementVNode("h2", { class: "h2 head-row" }, "輔導成果與花絮", -1)
const _hoisted_64 = { class: "row row-cols-1 cols-list event-list" }
const _hoisted_65 = { class: "event-item bg-white p-0 border" }
const _hoisted_66 = { class: "event-card-logo flex-shrink-0" }
const _hoisted_67 = { class: "event-card-info p-3 flex-grow-1 fcsb" }
const _hoisted_68 = { class: "h3 event-card-title text-primary mb-2" }
const _hoisted_69 = { class: "h5 event-card-des limitLine" }
const _hoisted_70 = /*#__PURE__*/_createElementVNode("div", { class: "h5 text-link-gray mt-md-0 mt-3" }, [
  /*#__PURE__*/_createElementVNode("u", null, "了解更多")
], -1)
const _hoisted_71 = { class: "frcc" }
const _hoisted_72 = { class: "row" }
const _hoisted_73 = { class: "col-md-10 mx-auto" }
const _hoisted_74 = /*#__PURE__*/_createElementVNode("h2", { class: "h2 head-row" }, "活動消息", -1)
const _hoisted_75 = { class: "row row-cols-1 row-cols-sm-2 row-cols-lg-3 cols-list event-list" }
const _hoisted_76 = { class: "event-item bg-white h-100 p-0" }
const _hoisted_77 = ["href", "title"]
const _hoisted_78 = { class: "event-card-logo" }
const _hoisted_79 = { class: "event-card-info p-3 border-top" }
const _hoisted_80 = { class: "event-card-date info-text mb-2" }
const _hoisted_81 = /*#__PURE__*/_createElementVNode("div", { class: "event-card-cate text-primary mb-2" }, "創業新訊", -1)
const _hoisted_82 = { class: "h5 event-card-title limitLine mb-2" }
const _hoisted_83 = /*#__PURE__*/_createElementVNode("div", { class: "tiny-link" }, [
  /*#__PURE__*/_createElementVNode("u", null, "了解更多")
], -1)
const _hoisted_84 = { class: "event-card-logo" }
const _hoisted_85 = { class: "event-card-info p-3 border-top" }
const _hoisted_86 = { class: "event-card-date info-text mb-2" }
const _hoisted_87 = /*#__PURE__*/_createElementVNode("div", { class: "event-card-cate text-primary mb-2" }, "創業新訊", -1)
const _hoisted_88 = { class: "h5 event-card-title limitLine mb-2" }
const _hoisted_89 = /*#__PURE__*/_createElementVNode("div", { class: "tiny-link" }, [
  /*#__PURE__*/_createElementVNode("u", null, "了解更多")
], -1)
const _hoisted_90 = ["href", "title"]
const _hoisted_91 = { class: "event-card-logo" }
const _hoisted_92 = { class: "event-card-info p-3 border-top" }
const _hoisted_93 = { class: "event-card-date info-text mb-2" }
const _hoisted_94 = /*#__PURE__*/_createElementVNode("div", { class: "event-card-cate text-primary mb-2" }, "近期活動", -1)
const _hoisted_95 = { class: "h5 event-card-title limitLine mb-2" }
const _hoisted_96 = /*#__PURE__*/_createElementVNode("div", { class: "tiny-link" }, [
  /*#__PURE__*/_createElementVNode("u", null, "了解更多")
], -1)
const _hoisted_97 = { class: "event-card-logo" }
const _hoisted_98 = { class: "event-card-info p-3 border-top" }
const _hoisted_99 = { class: "event-card-date info-text mb-2" }
const _hoisted_100 = /*#__PURE__*/_createElementVNode("div", { class: "event-card-cate text-primary mb-2" }, "近期活動", -1)
const _hoisted_101 = { class: "h5 event-card-title limitLine mb-2" }
const _hoisted_102 = /*#__PURE__*/_createElementVNode("div", { class: "tiny-link" }, [
  /*#__PURE__*/_createElementVNode("u", null, "了解更多")
], -1)
const _hoisted_103 = { class: "event-card-logo" }
const _hoisted_104 = { class: "event-card-info p-3 border-top" }
const _hoisted_105 = { class: "event-card-date info-text mb-2" }
const _hoisted_106 = /*#__PURE__*/_createElementVNode("div", { class: "event-card-cate text-primary mb-2" }, "亮點成果", -1)
const _hoisted_107 = { class: "h5 event-card-title limitLine mb-2" }
const _hoisted_108 = /*#__PURE__*/_createElementVNode("div", { class: "tiny-link" }, [
  /*#__PURE__*/_createElementVNode("u", null, "了解更多")
], -1)
const _hoisted_109 = /*#__PURE__*/_createStaticVNode("<div class=\"row\"><div class=\"col-md-10 mx-auto\"><div class=\"tutor-list\"><div class=\"tutor-item\"><div class=\"d-grid\"><div class=\"tutor-item-logo flex-shrink-0\"><img src=\"resources/images/logo/partner/GoogleForStartups_Vertical_CMYK.png\" alt=\"Google for Startups\" class=\"img-fluid h-auto\" style=\"object-position:top center;\"></div><div class=\"tutor-item-info flex-grow-1\"><div class=\"tutor-name-row frcb g-3\"><div class=\"h6 text-primary\">Google</div></div><div class=\"mb-2\"><div class=\"h3 mb-2\">企業簡介</div><p class=\"h4\"> Google 的使命是「彙整全球資訊，供大眾使用，使人人受惠」。自 1998 年創立以來，持續以創新科技改善全球用戶的生活。產品與服務涵蓋搜尋、Gemini、Gmail、Google Maps、YouTube、Android、Google Cloud 等，廣泛應用於日常生活、商業、教育與產業創新，是全球數位轉型的重要推手。 <br><br><a href=\"https://cloud.google.com/startup?e=48754805\" title=\"另開新視窗\" target=\"_blank\" rel=\"noopener noreferrer\" style=\"color:var(--primary);text-decoration:underline;\">Google Cloud for Startup</a> Program 為「Google 智慧台灣計畫」的核心項目之一，旨在透過 Google 的全球資源，號召各界有心人士共同為新創圈挹注資源，協助新創公司拓展多元機會。本計畫致力於發掘具備無限潛力的團隊，並鼓勵更多人才參與新創過程，協助其拓展國際市場與多元商機，創造強大而不間斷的創新動能，為台灣邁向「亞洲矽谷」以及「人工智慧島」的願景貢獻關鍵動能。 </p></div><div class=\"mb-2\"><div class=\"h3 mb-2\">合作資源</div><p class=\"h4\">我們專注於提供頂尖的 Google Cloud 解決方案，特別是在生成式 AI 與數據處理領域，打造具備高度競爭力的數位產品，協助新創公司在競爭激烈的市場中取得優勢。核心產品包括：</p><ul class=\"h4\"><li>AI 應用： 透過 Vertex AI平台,Model Garden 以及ADK，提供多樣的預訓練 AI 模型，加速模型開發與部署流程，快速打造生成式 AI 應用；並利用 Natural Language to Data 技術，將自然語言查詢直接轉換為數據洞察。</li><li>資料庫產品： 提供高效能、高擴展性的資料庫服務，滿足新創公司在數據儲存、管理與分析上的各種需求。</li><li>高效能 GPU / TPU 運算支援： 提供強大的 GPU / TPU 運算能力，協助團隊進行大規模模型訓練，並針對邊緣應用（Edge AI）進行模型優化與量化，確保模型在終端設備上也能高效運行。</li><li>Google Cloud 雲端架構諮詢： 由專業技術顧問提供一對一指導，協助團隊優化雲端部署方案、降低營運成本並強化資安防護。</li><li>全方位線上課程服務： 開放豐富的 Google Cloud 數位學習資源，涵蓋 AI 開發、大數據分析與架構設計，助力團隊成員持續提升技術實力。</li><li>Google Cloud for Startup Program 創新國際論壇入場資格： 匯聚全球產業領袖、資深創業家、投資人與技術專家，共同探討創新技術趨勢與商業轉型策略，媒合潛在合作機會。</li></ul></div><div class=\"btn-group frcc justify-content-md-end\"><a href=\"https://cloud.google.com/startup?e=48754805\" class=\"btn-primay has-icon filled square-arrow mx-2\" title=\"另開新視窗\" target=\"_blank\" rel=\"noopener noreferrer\">官方網站</a></div></div></div></div><div class=\"tutor-item\"><div class=\"d-grid\"><div class=\"tutor-item-logo flex-shrink-0\"><img src=\"resources/images/logo/partner/logo_crystalvision.png\" alt=\"晶瑞光電\" class=\"img-fluid h-auto\" style=\"object-position:top center;\"></div><div class=\"tutor-item-info flex-grow-1\"><div class=\"tutor-name-row frcb g-3\"><div class=\"h6 text-primary\">晶瑞光電</div></div><div class=\"mb-2\"><div class=\"h3 mb-2\">企業簡介</div><p class=\"h4\"> 晶瑞集團為全球濾光片、鏡頭模組與光學薄膜製程整合半導體微影技術之領導廠商，憑藉核心專利薄膜技術，成功打入國際頂尖供應鏈，具備高度競爭力之光學製造實力。 <br><br> 近年集團積極投入無人機與無人載具領域，並發展高階 AI 解決方案，致力轉型為「AI 視覺軟硬體整合方案商」。目前已成功進入多家全球一線無人機製造商供應鏈，展現技術落地能力。 <br><br> 未來將進一步結合光學優勢與 AI 視覺語言模型（VLM），發展高階視覺偵測與行為分析技術，將影像數據轉化為智慧決策，打造具高度競爭力之 AI 視覺系統架構，推動產業升級與創新應用。 </p></div><div class=\"mb-2\"><div class=\"h3 mb-2\">合作資源</div><p class=\"h4\">新創雲端成本優化支援計畫：</p><p class=\"h4\"> 針對早期雲端服務型新創團隊常見之營運痛點——在尚未達損益兩平前，即需承擔持續且高額的公有雲費用，晶瑞集團提供實質資源協助，降低營運壓力。 </p><ul class=\"h4\"><li>提供 AWS 雲端節費器（Cost Optimization Tool），協助團隊有效控管與優化雲端使用成本</li><li>在特定期間內提供免費使用資源，降低新創初期資金負擔</li><li>協助延長產品 Pivot 與市場驗證時間，提升商業模式調整彈性</li></ul><p class=\"h4\">透過降低基礎營運成本，讓新創團隊能更專注於產品開發與市場拓展，加速成長動能。</p></div></div></div></div></div></div></div>", 1)
const _hoisted_110 = [
  _hoisted_109
]
const _hoisted_111 = ["id"]
const _hoisted_112 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_113 = { class: "modal-content" }
const _hoisted_114 = /*#__PURE__*/_createElementVNode("div", { class: "ms-auto" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn-close",
    "data-bs-dismiss": "modal",
    "aria-label": "Close"
  })
], -1)
const _hoisted_115 = { class: "company-intro-main text-center" }
const _hoisted_116 = { class: "mb-1" }
const _hoisted_117 = ["id"]
const _hoisted_118 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_119 = { class: "modal-content" }
const _hoisted_120 = /*#__PURE__*/_createElementVNode("div", { class: "ms-auto" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn-close",
    "data-bs-dismiss": "modal",
    "aria-label": "Close"
  })
], -1)
const _hoisted_121 = { class: "company-intro-main text-center" }
const _hoisted_122 = { class: "mb-1" }
const _hoisted_123 = { class: "h4 mb-3" }
const _hoisted_124 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_pagination_component = _resolveComponent("pagination-component")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("main", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("section", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("nav", _hoisted_6, [
              _createElementVNode("ol", _hoisted_7, [
                _createElementVNode("li", _hoisted_8, [
                  _createVNode(_component_router_link, {
                    to: "/",
                    title: "首頁",
                    class: "foo: false"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("首頁")
                    ]),
                    _: 1
                  })
                ]),
                _hoisted_9
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("ul", _hoisted_12, [
                _createElementVNode("li", _hoisted_13, [
                  _createElementVNode("button", {
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.changeTab(1))),
                    class: _normalizeClass([{active: _ctx.tab == 1}, "nav-link tab-underline"]),
                    id: "funding1-tab",
                    "data-bs-toggle": "pill",
                    "data-bs-target": "#funding1",
                    type: "button",
                    role: "tab",
                    "aria-controls": "funding1",
                    "aria-selected": "true"
                  }, "計畫介紹 ", 2)
                ]),
                _createElementVNode("li", _hoisted_14, [
                  _createElementVNode("button", {
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.changeTab(4))),
                    class: _normalizeClass([{active: _ctx.tab == 4}, "nav-link tab-underline"]),
                    id: "funding4-tab",
                    "data-bs-toggle": "pill",
                    "data-bs-target": "#funding4",
                    type: "button",
                    role: "tab",
                    "aria-controls": "funding4",
                    "aria-selected": "false"
                  }, "活動消息 ", 2)
                ]),
                _createElementVNode("li", _hoisted_15, [
                  _createElementVNode("button", {
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.changeTab(2))),
                    class: _normalizeClass([{active: _ctx.tab == 2}, "nav-link tab-underline"]),
                    id: "funding2-tab",
                    "data-bs-toggle": "pill",
                    "data-bs-target": "#funding2",
                    type: "button",
                    role: "tab",
                    "aria-controls": "funding2",
                    "aria-selected": "false"
                  }, "企業導師與團隊 ", 2)
                ]),
                _createElementVNode("li", _hoisted_16, [
                  _createElementVNode("button", {
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.changeTab(6))),
                    class: _normalizeClass([{active: _ctx.tab == 6}, "nav-link tab-underline"]),
                    id: "funding6-tab",
                    "data-bs-toggle": "pill",
                    "data-bs-target": "#funding6",
                    type: "button",
                    role: "tab",
                    "aria-controls": "funding6",
                    "aria-selected": "false"
                  }, "輔導成果與花絮", 2)
                ]),
                _createElementVNode("li", _hoisted_17, [
                  _createElementVNode("button", {
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.changeTab(5))),
                    class: _normalizeClass([{active: _ctx.tab == 5}, "nav-link tab-underline"]),
                    id: "funding5-tab",
                    "data-bs-toggle": "pill",
                    "data-bs-target": "#funding5",
                    type: "button",
                    role: "tab",
                    "aria-controls": "funding5",
                    "aria-selected": "false"
                  }, "資源夥伴 ", 2)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_18, [
              _hoisted_19,
              _createElementVNode("div", {
                class: _normalizeClass([{active: _ctx.tab == 1, show: _ctx.tab == 1}, "tab-pane fade"]),
                id: "funding1",
                role: "tabpanel",
                "aria-labelledby": "funding1-tab",
                tabindex: "0"
              }, _hoisted_21, 2),
              _createElementVNode("div", {
                class: _normalizeClass([{active: _ctx.tab == 2, show: _ctx.tab == 2}, "tab-pane fade"]),
                id: "funding2",
                role: "tabpanel",
                "aria-labelledby": "funding2-tab",
                tabindex: "0"
              }, [
                (_ctx.years2.length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                      _createElementVNode("div", _hoisted_23, [
                        _hoisted_24,
                        _createElementVNode("div", _hoisted_25, [
                          _withDirectives(_createElementVNode("select", {
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.selectedYear2) = $event)),
                            onChange: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.onYearChange2 && _ctx.onYearChange2(...args))),
                            class: "form-select rounded-0",
                            "aria-label": "selectyear"
                          }, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.years2, (year) => {
                              return (_openBlock(), _createElementBlock("option", {
                                key: year,
                                value: year
                              }, _toDisplayString(year), 9, _hoisted_26))
                            }), 128))
                          ], 544), [
                            [_vModelSelect, _ctx.selectedYear2]
                          ])
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.years2.length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                      _createElementVNode("div", _hoisted_28, [
                        _createElementVNode("div", _hoisted_29, [
                          _createElementVNode("div", _hoisted_30, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.mentors, (item, index) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: item.id,
                                class: "tutor-item"
                              }, [
                                _createElementVNode("div", _hoisted_31, [
                                  _createElementVNode("div", _hoisted_32, [
                                    _createElementVNode("img", {
                                      src: item.file.path,
                                      alt: item.name,
                                      class: "img-fluid"
                                    }, null, 8, _hoisted_33)
                                  ]),
                                  _createElementVNode("div", _hoisted_34, [
                                    _createElementVNode("div", _hoisted_35, [
                                      _createElementVNode("div", _hoisted_36, [
                                        _createElementVNode("div", _hoisted_37, _toDisplayString(item.name), 1),
                                        _createElementVNode("button", {
                                          type: "button",
                                          class: "link-text btn-primay",
                                          "data-bs-toggle": "modal",
                                          "data-bs-target": '#companyIntroModal' + index
                                        }, "企業介紹", 8, _hoisted_38)
                                      ]),
                                      _hoisted_39,
                                      _createElementVNode("ul", _hoisted_40, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.introductions, (introduction) => {
                                          return (_openBlock(), _createElementBlock("li", { key: introduction }, _toDisplayString(introduction), 1))
                                        }), 128))
                                      ])
                                    ]),
                                    _createElementVNode("div", _hoisted_41, [
                                      (item.videoUrl)
                                        ? (_openBlock(), _createElementBlock("a", {
                                            key: 0,
                                            href: item.videoUrl,
                                            class: "btn-primay has-icon filled icon-video",
                                            title: "另開新視窗",
                                            target: "_blank",
                                            rel: "noopener noreferrer"
                                          }, "企業影片", 8, _hoisted_42))
                                        : _createCommentVNode("", true),
                                      (item.introductionUrl)
                                        ? (_openBlock(), _createElementBlock("a", {
                                            key: 1,
                                            href: item.introductionUrl,
                                            class: "btn-primay has-icon filled icon-link",
                                            title: "另開新視窗",
                                            target: "_blank",
                                            rel: "noopener noreferrer"
                                          }, "出題簡介", 8, _hoisted_43))
                                        : _createCommentVNode("", true),
                                      (item.website)
                                        ? (_openBlock(), _createElementBlock("a", {
                                            key: 2,
                                            href: item.website,
                                            class: "btn-primay has-icon filled square-arrow",
                                            title: "另開新視窗",
                                            target: "_blank",
                                            rel: "noopener noreferrer"
                                          }, "官方網站", 8, _hoisted_44))
                                        : _createCommentVNode("", true)
                                    ])
                                  ])
                                ])
                              ]))
                            }), 128))
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_45, [
                        _createElementVNode("div", _hoisted_46, [
                          _hoisted_47,
                          _createElementVNode("div", _hoisted_48, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.teams, (team, index) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: team.id,
                                class: "col align-self-stretch mb-4"
                              }, [
                                _createElementVNode("div", _hoisted_49, [
                                  _createElementVNode("a", {
                                    "data-bs-toggle": "modal",
                                    href: '#teamIntroModal' + index,
                                    role: "button"
                                  }, [
                                    _createElementVNode("div", _hoisted_51, [
                                      _createElementVNode("img", {
                                        class: "img-fluid",
                                        src: team.file.path,
                                        alt: team.name
                                      }, null, 8, _hoisted_52)
                                    ]),
                                    _createElementVNode("div", _hoisted_53, [
                                      _createElementVNode("div", _hoisted_54, _toDisplayString(team.name), 1),
                                      _hoisted_55
                                    ])
                                  ], 8, _hoisted_50)
                                ])
                              ]))
                            }), 128))
                          ])
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ], 2),
              _createElementVNode("div", {
                class: _normalizeClass([{active: _ctx.tab == 6, show: _ctx.tab == 6}, "tab-pane fade"]),
                id: "funding6",
                role: "tabpanel",
                "aria-labelledby": "funding6-tab",
                tabindex: "0"
              }, [
                (_ctx.highlights.length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
                      _createElementVNode("div", _hoisted_57, [
                        _hoisted_58,
                        _createElementVNode("div", _hoisted_59, [
                          _withDirectives(_createElementVNode("select", {
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.selectedYear3) = $event)),
                            onChange: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.onYearChange3 && _ctx.onYearChange3(...args))),
                            class: "form-select rounded-0",
                            "aria-label": "selectyear"
                          }, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.years3, (year) => {
                              return (_openBlock(), _createElementBlock("option", {
                                key: year,
                                value: year
                              }, _toDisplayString(year), 9, _hoisted_60))
                            }), 128))
                          ], 544), [
                            [_vModelSelect, _ctx.selectedYear3]
                          ])
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_61, [
                  (_ctx.highlights.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_62, [
                        _hoisted_63,
                        _createElementVNode("div", _hoisted_64, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.highlights, (item) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: item.id,
                              class: "col align-self-stretch mb-4"
                            }, [
                              _createElementVNode("div", _hoisted_65, [
                                _createVNode(_component_router_link, {
                                  to: {name: 'aiot-highlight-detail', params: { id: item.id }},
                                  class: "frths",
                                  title: item.name
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_66, [
                                      _createElementVNode("div", {
                                        class: "bg-wrapper",
                                        style: _normalizeStyle('background-image: url(' + item.file.path + ');')
                                      }, null, 4)
                                    ]),
                                    _createElementVNode("div", _hoisted_67, [
                                      _createElementVNode("div", null, [
                                        _createElementVNode("div", _hoisted_68, _toDisplayString(item.name), 1),
                                        _createElementVNode("p", _hoisted_69, _toDisplayString(item.description), 1)
                                      ]),
                                      _hoisted_70
                                    ])
                                  ]),
                                  _: 2
                                }, 1032, ["to", "title"])
                              ])
                            ]))
                          }), 128))
                        ]),
                        _createElementVNode("div", _hoisted_71, [
                          _createVNode(_component_pagination_component, {
                            class: "pagination-component",
                            totalPages: _ctx.totalPages3,
                            onOnClick: _ctx.changePage3
                          }, null, 8, ["totalPages", "onOnClick"])
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ], 2),
              _createElementVNode("div", {
                class: _normalizeClass([{active: _ctx.tab == 4, show: _ctx.tab == 4}, "tab-pane fade"]),
                id: "funding4",
                role: "tabpanel",
                "aria-labelledby": "funding4-tab",
                tabindex: "0"
              }, [
                _createElementVNode("div", _hoisted_72, [
                  _createElementVNode("div", _hoisted_73, [
                    _hoisted_74,
                    _createElementVNode("div", _hoisted_75, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.activities, (item) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: item.id,
                          class: "col align-self-stretch mb-4"
                        }, [
                          _createElementVNode("div", _hoisted_76, [
                            (item.type === 'news' && item.createType === 'AUTO' && item.link)
                              ? (_openBlock(), _createElementBlock("a", {
                                  key: 0,
                                  href: item.link,
                                  target: "_blank",
                                  rel: "noopener noreferrer",
                                  title: '[另開新視窗] ' + item.title
                                }, [
                                  _createElementVNode("div", _hoisted_78, [
                                    _createElementVNode("div", {
                                      class: "bg-wrapper",
                                      style: _normalizeStyle('background-image: url(' + (item.file1 ? item.file1.path : '/resources/images/placeholder-news.png') + ')')
                                    }, null, 4)
                                  ]),
                                  _createElementVNode("div", _hoisted_79, [
                                    _createElementVNode("div", _hoisted_80, _toDisplayString(_ctx.formatDate(item.createDate)), 1),
                                    _hoisted_81,
                                    _createElementVNode("div", _hoisted_82, _toDisplayString(item.title), 1),
                                    _hoisted_83
                                  ])
                                ], 8, _hoisted_77))
                              : (item.type === 'news')
                                ? (_openBlock(), _createBlock(_component_router_link, {
                                    key: 1,
                                    to: {name: 'news-detail', params: { id: item.id }},
                                    title: item.title
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("div", _hoisted_84, [
                                        _createElementVNode("div", {
                                          class: "bg-wrapper",
                                          style: _normalizeStyle('background-image: url(' + (item.file1 ? item.file1.path : '/resources/images/placeholder-news.png') + ')')
                                        }, null, 4)
                                      ]),
                                      _createElementVNode("div", _hoisted_85, [
                                        _createElementVNode("div", _hoisted_86, _toDisplayString(_ctx.formatDate(item.createDate)), 1),
                                        _hoisted_87,
                                        _createElementVNode("div", _hoisted_88, _toDisplayString(item.title), 1),
                                        _hoisted_89
                                      ])
                                    ]),
                                    _: 2
                                  }, 1032, ["to", "title"]))
                                : (item.type === 'event' && item.link)
                                  ? (_openBlock(), _createElementBlock("a", {
                                      key: 2,
                                      href: item.link,
                                      target: "_blank",
                                      rel: "noopener noreferrer",
                                      title: '[另開新視窗] ' + item.title
                                    }, [
                                      _createElementVNode("div", _hoisted_91, [
                                        _createElementVNode("div", {
                                          class: "bg-wrapper",
                                          style: _normalizeStyle('background-image: url(' + (item.file1 ? item.file1.path : '/resources/images/placeholder-event.png') + ')')
                                        }, null, 4)
                                      ]),
                                      _createElementVNode("div", _hoisted_92, [
                                        _createElementVNode("div", _hoisted_93, _toDisplayString(_ctx.formatDate(item.createDate)), 1),
                                        _hoisted_94,
                                        _createElementVNode("div", _hoisted_95, _toDisplayString(item.title), 1),
                                        _hoisted_96
                                      ])
                                    ], 8, _hoisted_90))
                                  : (item.type === 'event')
                                    ? (_openBlock(), _createBlock(_component_router_link, {
                                        key: 3,
                                        to: {name: 'events-detail', params: { id: item.id }},
                                        title: item.title
                                      }, {
                                        default: _withCtx(() => [
                                          _createElementVNode("div", _hoisted_97, [
                                            _createElementVNode("div", {
                                              class: "bg-wrapper",
                                              style: _normalizeStyle('background-image: url(' + (item.file1 ? item.file1.path : '/resources/images/placeholder-event.png') + ')')
                                            }, null, 4)
                                          ]),
                                          _createElementVNode("div", _hoisted_98, [
                                            _createElementVNode("div", _hoisted_99, _toDisplayString(_ctx.formatDate(item.createDate)), 1),
                                            _hoisted_100,
                                            _createElementVNode("div", _hoisted_101, _toDisplayString(item.title), 1),
                                            _hoisted_102
                                          ])
                                        ]),
                                        _: 2
                                      }, 1032, ["to", "title"]))
                                    : (_openBlock(), _createBlock(_component_router_link, {
                                        key: 4,
                                        to: {name: 'achievements-detail', params: { id: item.id }},
                                        title: item.title
                                      }, {
                                        default: _withCtx(() => [
                                          _createElementVNode("div", _hoisted_103, [
                                            _createElementVNode("div", {
                                              class: "bg-wrapper",
                                              style: _normalizeStyle('background-image: url(' + (item.file1 ? item.file1.path : '/resources/images/placeholder-event.png') + ')')
                                            }, null, 4)
                                          ]),
                                          _createElementVNode("div", _hoisted_104, [
                                            _createElementVNode("div", _hoisted_105, _toDisplayString(_ctx.formatDate(item.createDate)), 1),
                                            _hoisted_106,
                                            _createElementVNode("div", _hoisted_107, _toDisplayString(item.title), 1),
                                            _hoisted_108
                                          ])
                                        ]),
                                        _: 2
                                      }, 1032, ["to", "title"]))
                          ])
                        ]))
                      }), 128))
                    ])
                  ])
                ])
              ], 2),
              _createElementVNode("div", {
                class: _normalizeClass([{active: _ctx.tab == 5, show: _ctx.tab == 5}, "tab-pane fade"]),
                id: "funding5",
                role: "tabpanel",
                "aria-labelledby": "funding5-tab",
                tabindex: "0"
              }, _hoisted_110, 2)
            ])
          ])
        ])
      ])
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.mentors, (item, index) => {
      return (_openBlock(), _createElementBlock("div", {
        key: item.id,
        class: "modal fade",
        id: 'companyIntroModal' + index,
        tabindex: "-1",
        "aria-labelledby": "companyIntroModalLabel",
        "aria-hidden": "true"
      }, [
        _createElementVNode("div", _hoisted_112, [
          _createElementVNode("div", _hoisted_113, [
            _hoisted_114,
            _createElementVNode("div", _hoisted_115, [
              _createElementVNode("h3", _hoisted_116, _toDisplayString(item.name), 1),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.contents, (content) => {
                return (_openBlock(), _createElementBlock("p", {
                  key: content,
                  class: "h4"
                }, _toDisplayString(content), 1))
              }), 128))
            ])
          ])
        ])
      ], 8, _hoisted_111))
    }), 128)),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.teams, (team, index) => {
      return (_openBlock(), _createElementBlock("div", {
        key: team.id,
        class: "modal fade",
        id: 'teamIntroModal' + index,
        tabindex: "-1",
        "aria-labelledby": "teamIntroModalLabel",
        "aria-hidden": "true"
      }, [
        _createElementVNode("div", _hoisted_118, [
          _createElementVNode("div", _hoisted_119, [
            _hoisted_120,
            _createElementVNode("div", _hoisted_121, [
              _createElementVNode("h3", _hoisted_122, _toDisplayString(team.name), 1),
              _createElementVNode("p", _hoisted_123, _toDisplayString(team.description), 1),
              _createElementVNode("a", {
                href: team.website,
                class: "btn-primay has-icon filled square-arrow",
                title: "另開新視窗",
                target: "_blank",
                rel: "noopener noreferrer"
              }, "官方網站", 8, _hoisted_124)
            ])
          ])
        ])
      ], 8, _hoisted_117))
    }), 128))
  ], 64))
}